import { render, staticRenderFns } from "./DashboardMobile.vue?vue&type=template&id=4a54a352&scoped=true&"
import script from "./DashboardMobile.vue?vue&type=script&lang=js&"
export * from "./DashboardMobile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMobile.vue?vue&type=style&index=0&id=4a54a352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54a352",
  null
  
)

export default component.exports